import { Body1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectAsideCompactMode } from 'shared/selectors/aside';
import { selectFloorTitle } from 'shared/selectors/newbuilding';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';
import { selectOfferTitle } from 'shared/selectors/selectOfferTitle';

export function OfferTitleSidebarContainer() {
  const title = useSelector(selectOfferTitle);
  const isCompactModeEnabled = useSelector(selectAsideCompactMode);
  const floorTitle = useSelector(selectFloorTitle);
  const isBooked = useSelector(selectIsBookedFromDeveloper);

  if (!isCompactModeEnabled) {
    return null;
  }

  return (
    <Body1 data-testid="offer-title-sidebar" color={isBooked ? 'text-secondary-default' : undefined}>
      {title}
      {floorTitle}
    </Body1>
  );
}
